import { Button, Typography } from "@material-ui/core";
import { PrimaryButton } from "../components-atoms";
import GeneralModal from "./GeneralModal";


interface SubscriptionActivateShopModalProps {
    isVisible: boolean;
    close: () => void;
    activate: () => void;
}

export function SubscriptionActivateShopModal({ isVisible, close, activate }: SubscriptionActivateShopModalProps): JSX.Element {
    return (
        <GeneralModal
            title="Activate subscription"
            description="Are you sure you want to activate this subscription?"
            visible={isVisible}
            onClose={() => close()}
            modalWidth="560px"
        >
            <GeneralModal.ButtonArea>
                <Button onClick={() => close()}>
                    <Typography
                        variant="button"
                        component="p"
                        color="primary">
                        Cancel
                    </Typography>
                </Button>
                <PrimaryButton
                    title="Activate"
                    onClick={() => activate()}
                />
            </GeneralModal.ButtonArea>
        </GeneralModal>
    );
}
